import React, {useState} from 'react';
import Modal from 'react-modal';
import { useIsPageDesktop } from '../../App';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import { activateCompanyUser, activateUser } from '../../service/UserService';

export default function ActivateUserModal(props) {

    const isActivateModalOpen = props.isActivateModalOpen;
    const setIsActivateModalOpen = props.setIsActivateModalOpen;
    const activateChangeTo = props.activateChangeTo;
    const updateUser = props.updateUser;
    const companyNumber = props.companyNumber;
    const editPageUpdate = props.editPageUpdate;
    const isDesktop = useIsPageDesktop();
    const [isLoading, setIsLoading] = useState(false);
    const user = props.user;
    const [reason, setReason] = useState("");
    
    const handleInputChange = (event) => {
        const sanitizedText = event.target.value.replace(/[^\w\s]/gi, '');
        const limitedText = sanitizedText.slice(0, 100);
        setReason(limitedText);
    };

    const handleClose = () => {
        setIsActivateModalOpen(false);
        setReason("");
    }

    const handleActivate = () => {
        setIsLoading(true);
        updateUser("isActive", activateChangeTo);
        if(editPageUpdate != null){
            editPageUpdate();
            if (companyNumber){
                activateCompanyUser(companyNumber, user.uuid, reason, activateChangeTo, callbackHandler);
            }
            else {
                activateUser(user.uuid, reason, activateChangeTo, callbackHandler);
            }
        }
        else{
            if (companyNumber){
                activateCompanyUser(companyNumber, user.uuid, reason, activateChangeTo, callbackHandler);
            }
            else {
                activateUser(user.uuid, reason, activateChangeTo, callbackHandler);
            }
        }
    }

    const callbackHandler = (data) => {
        setIsLoading(false);
        setIsActivateModalOpen(false);
        setReason("");
    }

    return (
        <Modal 
            isOpen={isActivateModalOpen}
            overlayClassName="confirmation-overlay"
            className="confirmation-modal"
            onRequestClose={() => handleClose()}
            tabIndex={0}>
            <div className="efup-modal" id="confirmationModal" data-testid="efup-overview-tab-confirmation-modal">
                <div className="cb-modal-dialog" style={{minWidth: "700px"}} role="document">
                    <div className="cb-modal-content">
                        <div className="cb-modal-header">
                            <h2 className="cb-modal-title" data-testid="efup-overview-tab-confirmation-modal-title">{activateChangeTo ? "Activate " + user.username + "?" : "Inactivate " + user.username + "?" }</h2>
                            <i
                                className="cb-close cb-icon icon-close"
                                aria-hidden="true" 
                                data-dismiss="cb-modal" 
                                aria-label="Close" 
                                onClick={() => handleClose()}
                                tabIndex={0} onKeyDown={({key}) => key === "Enter" ? handleClose() : ""}
                                data-testid="efup-overview-tab-confirmation-modal-close-button"
                            />
                        </div>
                        {isLoading ?
                            <div className="cb-modal-body">
                                <div className='confirmation-modal-loading-spinner'>
                                    <LoadingSpinner blue data-testid='efup-overview-tab-confirmation-modal-loading-spinner' />
                                    <p className='loading-spinner-text'>In progress...</p>
                                </div>
                            </div>:
                            <div>
                                <div>
                                    <div className="cb-modal-body" data-testid="efup-overview-tab-confirmation-modal-areYouSure" >
                                            <p> Inactive users can still log in, but are prevented from viewing any payment data through PreferPay Insights. Do you want to continue? </p>
                                            <label htmlFor='reason-input'>Reason:</label>
                                            <textarea
                                                type='text'
                                                value={reason}
                                                id='reason-input'
                                                onChange={handleInputChange}
                                                maxLength={100}
                                                style={{
                                                    width: '100%',  
                                                    resize: 'vertical',
                                                    maxHeight: '6em'
                                                  }}
                                            />
                                    </div>
                                    <div className="cb-modal-footer">
                                        <div className={isDesktop ? "": "mobileButtons"}>
                                            <button
                                                type="button"
                                                className="cb-btn cb-btn-primary confirmation-modal-confirm-btn"
                                                data-testid="efup-overview-tab-confirmation-modal-confirm-button"
                                                data-dismiss="cb-modal"
                                                disabled={!reason}
                                                onClick={() => handleActivate()}>
                                                Confirm 
                                            </button>
                                            <button
                                                type="button"
                                                className="cb-btn cb-btn-outline-secondary confirmation-modal-cancel-btn"
                                                data-testid="efup-overview-tab-confirmation-modal-cancel-button"
                                                data-dismiss="cb-modal"
                                                onClick={() => handleClose()}>
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </Modal>                                                
    );
}